var exports = {
  "az": "Box__P18mwu",
  "wy": "Box_1__ngX7oI",
  "EY": "Text__dlQ_mD",
};

module.exports = exports;
